import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

var configApp = null;
if (process.env.NODE_ENV !== 'production') {
  configApp = require('../config/config.development.json');
} else {
  configApp = require('../config/config.production.json');
}

axios.defaults.baseURL = configApp.backendUrl;

Vue.configApp = configApp;
Vue.use(VueAxios, axios)

import App from './App.vue'
import router from './router'
import store from './store/store'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret,faUser,faPowerOff, faSearch, faPlayCircle, faEye, faStar, faCircle, faClock, faListAlt } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faUserSecret,faUser,faPowerOff,faSearch,faPlayCircle,faEye,faStar,faCircle,faClock,faListAlt)
library.add(far)
library.add(fab)

Vue.component('ficon', FontAwesomeIcon)

import './assets/css/myiptv.scss';
import './assets/css/pandora_login.css';
import './assets/css/fonts.scss';


//console.log(process.env.NODE_ENV, configApp);

Vue.config.productionTip = false

Vue.mixin({
  data: function() {
    return {
      configApp: configApp
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
  created: function() {
    this.configApp = configApp;
  }  
}).$mount('#app')
